// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// aos动画
import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import animate from 'animate.css'
//引入谷歌统计
import VueGtag from "vue-gtag";



import { Button, Row, Col, Input, Form, FormItem, Link, Carousel, CarouselItem, Image, Message } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
Vue.config.productionTip = false
;[Button, Row, Col, Input, Form, FormItem, Link, Carousel, CarouselItem, Image].forEach(c => Vue.use(c))
Vue.prototype.$message = Message
locale.use(lang)
Vue.use(AOS)
Vue.use(VueVideoPlayer)
Vue.use(animate)
//初始化谷歌统计插件
Vue.use(VueGtag, {
  config: { id: "G-Q1NETJZ8N9" },
  includes: [
	  { id: 'G-ZLCH83L8Z7' }
	]
}, router);
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js